<template>
  <div class="brand-container">
    <el-select
      v-if="companySource && companySource.length"
      v-model="company"
      filterable
      :show-hover="false"
      @change="changeCompany"
      class="brand-select"
      popper-class="translate_x_96"
    >
      <template slot="prefix">
          <span class="prefix-text">公司</span>
          <el-divider direction="vertical"></el-divider>
      </template>
      <el-option
        v-for="item in companySource"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { companyList, purchaseMallLogOut } from '@/api/login'

export default {
  data() {
    return {
      company: 0,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'companySource']),
    companyName() {
      if (this.companySource && this.companySource.length) {
        const comId = this.userInfo && this.userInfo.sessionCompanyId
        const company = this.companySource.find((com) => (!comId && com.type === 2) || (comId === com.id))
        if (company) {
          return company
        }
      }
      return ''
    },
  },
  created() {
    this.queryCompany()
  },
  methods: {
    changeCompany(index) {
      const item = this.companySource.find((i) => i.id === index)
      const companyId = item.type === 2 ? 0 : item.id
      this.dataBase.deleteAll()
      this.$store.dispatch('SwitchCompany', {
        companyId,
      })
      purchaseMallLogOut({
        phone: this.userInfo.userMobile,
        companyId: this.userInfo.sessionCompanyId,
        userName: this.userInfo.userName,
        userId: this.userInfo.id,
      })
    },
    queryCompany() {
      companyList().then(({ code, data: items }) => {
        const comId = this.userInfo && this.userInfo.sessionCompanyId
        if ((code === 1) && items && items.length) {
          // this.company = items.findIndex(com => (!comId && com.type === 2) || (comId === com.id))
          if (comId) {
            this.company = comId
          } else {
            items.forEach((item) => {
              if (item.type === 2) {
                this.company = item.id
              }
            })
          }
          this.$store.commit('SET_COMPANYNAME', this.companyName)
          this.$store.commit('SET_COMPANY_SOURCE', items)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.brand-container {
  margin-right: 20px;

  .brand-select {
    width: 260px;
    line-height: 32px;

    ::v-deep .el-input__inner {
      box-sizing: border-box;
      border: 1px solid #F5F9FF;
      box-shadow: none;
      background: #F5F9FF;
      border-radius: 5px;
      color: rgba(0, 0, 0, 0.7);
      padding-left: 53px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ::v-deep .el-input__inner:hover {
      box-shadow: none;
      border: 1px solid #276BEC;
    }

    ::v-deep .el-input__inner:focus {
      box-shadow: none;
      border: 1px solid #276BEC;
      box-shadow: 0px 0px 4px 0px #276BEC;
    }

    ::v-deep .el-input__inner::-webkit-input-placeholder {
      color: rgba(0, 0, 0, 0.7);
    }

    ::v-deep .el-select__caret {
      color: #9A9A9A;
    }

    ::v-deep .el-input__prefix {
      left: 8px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
}
</style>
